import RemboMark from "./RemboMark";
import "./css/rembo_logo.css";

const MARK_SIZE = { sm: 22, md: 30, lg: 40 };

// Brand lockup: the RL monogram plus the "RemboList" wordmark, used wherever
// the sidebar/topbar/auth text logo used to render "Rembo<span>List</span>"
// with no actual mark. `theme` controls the accent color so "List" stays
// legible on both dark (sidebar) and light (auth) surfaces.
export default function RemboLogo({ variant = "full", theme = "light", size = "md", className }) {
  const markSize = MARK_SIZE[size] || MARK_SIZE.md;

  if (variant === "mark") {
    return (
      <span className={`rl-logo rl-logo--mark${className ? ` ${className}` : ""}`}>
        <RemboMark size={markSize} variant="solid" title="RemboList" />
      </span>
    );
  }

  const wordmark = (
    <span className="rl-logo-word">
      Rembo<span className={`rl-logo-accent rl-logo-accent--${theme}`}>List</span>
    </span>
  );

  return (
    <span
      className={`rl-logo rl-logo--${variant} rl-logo--${theme} rl-logo--${size}${className ? ` ${className}` : ""}`}
    >
      <RemboMark size={markSize} variant="solid" />
      {wordmark}
    </span>
  );
}
